import { render, staticRenderFns } from "./ArtisanDrawer.vue?vue&type=template&id=3e621255&scoped=true"
import script from "./ArtisanDrawer.vue?vue&type=script&lang=js"
export * from "./ArtisanDrawer.vue?vue&type=script&lang=js"
import style0 from "./ArtisanDrawer.vue?vue&type=style&index=0&id=3e621255&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e621255",
  null
  
)

export default component.exports